import styles from './Dashboard.module.scss'
import productList from '../utils/products'
import { useNavigate, useLocation } from 'react-router-dom'

function Dashboard() {
  const navigate = useNavigate();
  const handleDetail = (item) => {
    navigate('/dashDetail/' + item.key);
  }
  return <>
    <div className={styles.Dashboard}>
      <div className={styles.Dashboard_title}>产品中心</div>
      <div className={styles.Dashboard_box}>
        {productList.map(item => <div className={styles.Dashboard_box_item} onClick={() => handleDetail(item)}>
          <img src={item.img} />
          <div>
            {item.title}
            <div>查看详情</div>
          </div>
        </div>)}
      </div>
    </div>
  </>;
}

export default Dashboard;